@use "variables" as *;

.circularProgress {
  width: 24px !important;
  height: 24px !important;
}
